export const columnsDataStudyPlans = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Nombre",
    accessor: "description",
  },
  {
    Header: "Fecha de vigencia",
    accessor: "startDate",
  },
  {
    Header: "Estudio",
    accessor: "study.description",
  },
  {
    Header: "Tipo de estudio",
    accessor: "study.studyTypeDescription",
  },
];
